import {ModifierFragment} from '../../../gql/graphql';
import {PriceModel} from './Price.model';
import {ModelContext} from '../../../types/checkoutApp.types';

export class ModifierModel {
  public quantity?: number;
  public label: string;
  public details?: string;
  public price?: PriceModel;

  constructor(modifier: ModifierFragment, modelContext: ModelContext) {
    this.quantity = modifier.quantity ?? undefined;
    this.label = modifier.label?.translated ?? modifier.label?.original ?? /* istanbul ignore next */ '';
    this.details = modifier.details?.translated ?? modifier.details?.original ?? /* istanbul ignore next */ undefined;
    this.price = modifier.price ? new PriceModel(modifier.price, modelContext) : undefined;
  }
}
